import ImageCompressor from 'compressorjs'

async function handleImageUpload(image, imagePreset = 'instagram') {
  const isAvatar = imagePreset === 'instagram-avatar'
  const maxWidth = isAvatar ? 200 : 500

  const blob = await compressImage(image, maxWidth)

  const data = new FormData()
  data.append('file', blob)
  data.append('upload_preset', imagePreset)
  data.append('cloud_name', 'dkcqcl5yq')

  const response = await fetch(
    'https://api.cloudinary.com/v1_1/dkcqcl5yq/image/upload',
    {
      method: 'POST',
      accept: 'application/json',
      body: data
    }
  )

  const jsonResponse = await response.json()
  return jsonResponse.secure_url
}

function compressImage(file, maxWidth) {
  return new Promise((resolve, reject) => {
    new ImageCompressor(file, {
      quality: 0.9,
      maxWidth,
      success: resolve,
      error: reject
    })
  })
}

export default handleImageUpload
